import $ from 'jquery';

$('.help-interferer__pages').on('change', function() {
    var selectedValue = $(this).find( "option:selected" ).attr('value');

    $(this).siblings().removeClass('help-interferer__links--active');
    if(selectedValue) {
        $(this).siblings('[data-item="' + selectedValue + '"]').addClass('help-interferer__links--active');
    }
    else {
        $(this).siblings('[data-item="1"]').addClass('help-interferer__links--active');
    }

});

$('.help-interferer__links').on('change', function() {
    var selectedValue = $(this).find( "option:selected" ).attr('value');
    if(selectedValue) {
        window.open(selectedValue, "_self");
        
    }
});
